import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
import ScrollReveal from "scrollreveal"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function buildFormat() {
      var $toc = $('<div />', {id: 'toc_container'});
      var $list = $('<ul />', {class: 'toc_list'});
      var $groups = $('.u-format-group');
      // フォーマットグループごとの処理
      for (var i = 0; i < $groups.length; i++) {
        var $_list = $('<ul />');
        var $group = $($groups[i]);
        var group_title = $group.find('.u-format-group__title').text();
        var $group_li = $('<li />');
        var groupid = 'formatgroup_' + (i + 1);
        $group.attr('id', groupid);
        $list.append(
          $group_li.append(
            $('<a />',
              {
                text: (i + 1) + '. ' + group_title,
                href: '#' + groupid
              }
            )
          )
        );
        // フォーマットごとの処理
        var $formats = $group.find('.u-format-group__content').find('.u-format');
        var $_ul = $('<ul />');
        for (var m = 0; m < $formats.length; m++) {
          var $format = $($formats[m]);
          var $format_title = $format.find('.u-format__title');
          var $format_content = $format.find('.u-format__content');
          var formatid = 'format_' + (i + 1) + (m + 1);
          $format.find('.u-format__title').attr('id', formatid);
          var format_title = $format_title.text();
          var format_number = (i + 1) + '.' + (m + 1) + '. ';
          $format_title.text(format_number + format_title);
          $_ul.append(
            $('<li />').append(
              $('<a />', {
                  href: '#' + formatid,
                  text: format_number + format_title
                }
              )
            )
          );

          // コードを追加
          var $code = $('<div />', {class: 'u-format__code'});
          $code.append($('<div />', {
            class: 'u-format__code__title',
            text: format_number + format_title
          }));
          var formathtml = $format.find('.u-format__content').html();
          $code.append($('<pre />', {text: formathtml.trim()}));
          $format.append($code);
        }
        $group_li.append($_ul);
        $_list.append($group_li);
        $list.append($_list);
      }
      $toc.append($list);
      $('.c-breadcrumb').after(
        $('<div />', {
            class: 'l-container'
          }
        ).append($toc)
      );
    }

    function scrollDots() {
      if ($(".c-dot-navi").length <= 0) {
        return;
      }
      var offset = -240;
      var el1 = $(".c-dot-navi li:nth-child(1) a").attr("data-anchor-target");
      var el1_start_pos = $(el1)[0].offsetTop + offset;
      var el2 = $(".c-dot-navi li:nth-child(2) a").attr("data-anchor-target");
      var el2_start_pos = $(el2)[0].offsetTop + offset;
      var el3 = $(".c-dot-navi li:nth-child(3) a").attr("data-anchor-target");
      var el3_start_pos = $(el3)[0].offsetTop + offset;
      var el4 = $(".c-dot-navi li:nth-child(4) a").attr("data-anchor-target");
      var el4_start_pos = $(el4)[0].offsetTop + offset;
      var el5 = $(".c-dot-navi li:nth-child(5) a").attr("data-anchor-target");
      var el5_start_pos = $(el5)[0].offsetTop + offset;
      var el6 = $(".c-dot-navi li:last-child a").attr("data-anchor-target");
      var el6_start_pos = $(el6)[0].offsetTop + offset;
      var start_pos = el1_start_pos + offset;
      var end_pos = $(el6)[0].offsetTop + $(el6)[0].offsetHeight + offset;

      $(window).on('scroll', function (event) {
        var scroll_top = $(window).scrollTop();

        if (scroll_top >= start_pos) {
          $(".c-dot-navi").addClass("is-enable");

          if (scroll_top >= el6_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(6)").addClass("is-active");
          } else if (scroll_top >= el5_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(5)").addClass("is-active");
          } else if (scroll_top >= el4_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(4)").addClass("is-active");
          } else if (scroll_top >= el3_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(3)").addClass("is-active");
          } else if (scroll_top >= el2_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(2)").addClass("is-active");
          } else if (scroll_top >= el1_start_pos) {
            $(".c-dot-navi li").removeClass("is-active");
            $(".c-dot-navi li:nth-child(1)").addClass("is-active");
          }

        }

        if (scroll_top >= end_pos || scroll_top <= start_pos) {
          $(".c-dot-navi").removeClass("is-enable");
        }


      });
    }

    $(function () {
      $('.c-voice__inner.owl-carousel').owlCarousel({
        dots: false,
        loop: true,
        nav: true,
        autoplay: true,
        autoplaySpeed: 1800,
        autoWidth: false,
        autoHeight: false,
        nav: true,
        navText: ['<img src="/wp-content/themes/o-and-k-html/dist/assets/images/img-slider-prev.png" />', '<img src="/wp-content/themes/o-and-k-html/dist/assets/images/img-slider-next.png" />'],
        responsive: {
          0: {
            margin: 20,
            items: 2,

          },
          900: {
            margin: 36,
            items: 3,
          }
        }
      });

      var $mainSlider = $('.c-main-visual__slider')
      $mainSlider.owlCarousel({
        //下部のインジゲーターはCSSで時間調整してください。
        callbacks: true,
        items: 1,
        margin: 0,
        dots: true,
        loop: true,
        nav: true,
        animateOut: 'fadeOut',
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 2000,
        center: true,
        navText: ['<img src="/wp-content/themes/o-and-k-html/dist/assets/images/icon-slider-prev.png" />', '<img src="/wp-content/themes/o-and-k-html/dist/assets/images/icon-slider-next.png" />'],
        responsive: {
          0: {
            nav: false,
            dots: true
          },
          750: {
            nav: false,
            dots: true
          },
          950: {
            dots: true,
            nav: true,
          }
        }
      });
      //イベントの設定
      $mainSlider.on('changed.owl.carousel', function (e) {
      });
      //buildFormat();
      scrollDots();
    });
  }
}

window.GApp = new App();


(function ($) {

  var growApp = function () {
  };
  // /*
  //  * userAgent取得
  //  * */
  // var Agent = window.navigator.userAgent.toLowerCase();
  // var _ua = (function (u) {
  //   return {
  //     Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
  //       || u.indexOf("ipad") != -1
  //       || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
  //       || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
  //       || u.indexOf("kindle") != -1
  //       || u.indexOf("silk") != -1
  //       || u.indexOf("playbook") != -1,
  //     Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
  //       || u.indexOf("iphone") != -1
  //       || u.indexOf("ipod") != -1
  //       || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
  //       || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
  //       || u.indexOf("blackberry") != -1
  //   }
  // })(Agent);
  //
  // growApp.prototype.changeViewPort = function () {
  //
  //   //ビューポート処理
  //   if (_ua.Mobile) {
  //     $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
  //   } else {
  //     $('head').prepend('<meta name="viewport" content="width=1100">');
  //   }
  // };

  /*
  *
  * スマホメニューの高さを取得する
  *
  * */
  growApp.prototype.menuHight = function () {
    var win = $(window).innerWidth();
    if (win > 750) {
      return false;
    }

    var $smpHeaderHeight = $('.l-header').height();
    var windowHeight = window.innerHeight;
    var winH = windowHeight - $smpHeaderHeight;

    console.log($smpHeaderHeight);

    //動かすターゲットを取得
    var targetSlidebarWrap = $('.c-slidebar-menu'),
      targetSlidebarMenu = $('.c-slidebar__parent'),
      targetSlidebarBtn = $('.c-slidebar-menu__parent');


    //いざ実行(クリックしたら処理を実行する)
    targetSlidebarBtn.on('click', function () {
      $('.c-slidebar-menu').toggleClass('is-active');

    });

  }

  growApp.prototype.footerMenu = function () {
    var win = $(window).innerWidth();
    if (win > 750) {
      return false;
    }
    $('.c-footer-menu__block').on('click', function () {
      $(this).children(".c-footer-menu__title").toggleClass('is-open');
      $(this).children(".c-footer-menu__list.is-sub").slideToggle();
    })
  }

  growApp.prototype.scrollReveal = function () {
    //- スクロールリーバル
    window.sr = ScrollReveal({duration: 600, mobile: false});

    function domEach(items, callback) {
      if (typeof items === "string") {
        var items = $(items);
      }
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        // callback = callback.bind(item)
        callback(i, item);
      }
    }

    //top
    sr.reveal(".c-opening,.c-voice.is-top", {
      delay: 400,
      scale: 1,
      duration: 2000,
      origin: 'bottom',
      distance: '50px',
    }, 100);
    sr.reveal(".c-opening__inner.is-left", {
      delay: 1000,
      scale: 1,
      duration: 2000,
      origin: 'left',
      distance: '50px',
    }, 100);
    sr.reveal(".c-opening__inner.is-right", {
      delay: 1000,
      scale: 1,
      duration: 2000,
      origin: 'right',
      distance: '50px',
    }, 100);

    //lower
    sr.reveal(".c-page-header", {delay: 400, scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);
    sr.reveal(".c-page-header__inner", {
      delay: 800,
      scale: 1,
      duration: 2000,
      origin: 'bottom',
      distance: '50px',
    }, 100);
    sr.reveal(".l-main.is-lower", {delay: 1200, scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);

    /*
    var blocks01 = $(".c-section-title__title");
    domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1,duration: 700,delay: 700}, 200);
        sr.reveal(item.children[1], {delay: 800, scale: 1,origin: 'bottom', distance: '40px'}, 300);
        sr.reveal(item.children[2], {delay: 900, scale: 1,origin: 'bottom', distance: '40px'}, 300);
        sr.reveal(item.children[3], {delay: 1000, scale: 1,origin: 'bottom', distance: '40px'}, 300);

    });
    */
  }

  growApp.prototype.snsAutoHeight = function () {
    var target = $('.c-sns');
    if ( target.length === 0) {
      return false;
    }

    target.height($(window).innerHeight());
  }

  $(function () {
    var app = new growApp();
    //app.changeViewPort();
    // app.menuHight();
    //app.footerMenu();
    app.scrollReveal();
    app.snsAutoHeight();
  });

})(jQuery);

